import React, { Fragment } from 'react';

import { DesktopOnly, MobileOnly } from 'shared/components';
import DispensarySubheaderDesktop from './dispensary-subheader-desktop';
import DispensarySubheaderMobile from './dispensary-subheader-mobile';

export default function DispensarySubheaderWrapper({ dispensary }) {
  return (
    <Fragment>
      <DesktopOnly>
        <DispensarySubheaderDesktop dispensary={dispensary} />
      </DesktopOnly>

      <MobileOnly>
        <DispensarySubheaderMobile />
      </MobileOnly>
    </Fragment>
  );
}
